import React from 'react';

const Header = () => (
	<section className="hero is-primary is-bold">
			<div className="hero-body">
				<div className="container">
					<h1 className="title">
						Transporte por Aplicativo
					</h1>
					<h2 className="subtitle">
						Prefeitura Municipal de Indaiatuba
				</h2>
				</div>
			</div>
		</section>
);

export default Header;